jQuery(document).ready(function ($) {
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    $('.dp__popup').each((index, element) => {
        let popupId = $(element).data('popupid');
        let popupCookieName = `popup-${popupId}`;
        let getPopupCookie = getCookie(popupCookieName);

        let popupDelay = $(element).data('delay');

        if($(element).hasClass('await')) {
            return;
        }

        // Set active class if cookie does not exist or is false
        if (!getPopupCookie) {
            if (popupDelay !== undefined) {
                setTimeout(() => {
                    $(element).addClass('dp__popup--active');
                }, popupDelay);
            } else {
                $(element).addClass('dp__popup--active');
            }
        }
    });

    $('.dp__popup-close-button').on('click', function () {
        let popupEl = $(this).parent().parent();
        let popupId = $(popupEl).data('popupid');
        let popupCookieName = `popup-${popupId}`;
        setCookie(popupCookieName, 1, 30);
        $(popupEl).removeClass('dp__popup--active');
    });

    $('.dp__popup-open-button').on('click', function() {
        // get data-attribute "popupid" from button
        let popupId = $(this).data('popupid');

        // Search for popup with corresponding popupid
        let popupElement = $(`.dp__popup[data-popupid="${popupId}"]`);

        // Add class to element
        popupElement.addClass('dp__popup--active');
    });
});
